/* global axios */
import ApiClient from './ApiClient';

class UserRolesAPI extends ApiClient {
  constructor() {
    super('user_roles', { accountScoped: true });
  }

  updateUserLimit(roleId, accountUserId, maxConversationsOverride) {
    return axios.patch(`${this.url}/${roleId}/update_user_limit`, {
      account_user_id: accountUserId,
      max_conversations_override: maxConversationsOverride,
    });
  }
}

export default new UserRolesAPI();
